export default function () {
    let $initElem = $('.geo-city');

    if ($initElem.length === 0) {
        return;
    }

    let $body = $('body');

    let clearError = () => {
        $('.modal-geo_form-form .geo-city').removeClass('has-error');
        $('.geo-city-result-help').html('');
    };

    $body.on('click', '.geo-form--submit', (e) => {
        e.preventDefault();

        if ($('#city-geo-id').val() === '') {
            $('.modal-geo_form-form .geo-city').addClass('has-error');
            $('.geo-city-result-help').html('Выберите город из списка.');
        } else {
            $('.modal-geo_form-form').submit();
        }
    });

    $body.on('click', '.modal__list-cities__link', (e) => {
        e.preventDefault();

        let $elem = $(e.target);
        let name = $elem.text().trim();
        let id = $elem.data('id');

        $initElem.val(name);
        $('#city-geo-id').val(id);
    });

    $('.modal-geo_form-form .geo-city').focus(() => {
        clearError();
    });

    /**
     * Comparison
     * @param obj
     * @param item
     * @returns {boolean|*}
     */
    let getCurrentItem = (obj, item) => {
        if (!Object.prototype.hasOwnProperty.call(obj, 'content') ||
            obj.content.length === 0 || item.length === 0
        ) {
            return false;
        }

        let result = obj.content.filter((it) => {
            return it.name.toLowerCase() === item.toLowerCase() ? it : false;
        });

        return result.length > 0 ? result[0] : false;
    };

    // eslint-disable-next-line no-underscore-dangle
    $initElem.autocomplete({
        delay: 200,
        appendTo: '#geo-city-result',
        minLength: 2,
        source: (request, response) => {
            $.ajax({
                url: `index.php?route=wm_geo/wm_geo/cityAutocomplete&filter_name=${encodeURIComponent(request.term)}`,
                dataType: 'json',
                success: (json) => {
                    response($.map(json, (item, index) => {
                        return {
                            label: item.label,
                            name: item.name,
                            id: item.id,
                        };
                    }));
                },
            });
        },
        select: (event, ui) => {
            let $elem = $(event.target);
            $elem.val(ui.item.name);
            $elem.next().val(ui.item.id);
            clearError();

            return false;
        },
        focus: () => {
            return false;
        },
        response: (event, ui) => {
            clearError();

            let $elem = $(event.target);
            let inVal = $(event.target).val();
            let result = getCurrentItem(ui, inVal);

            if (result) {
                $elem.next().val(result.id);
                $initElem.autocomplete('close');
            } else {
                $elem.next().val('');
            }
        },
    }).data('ui-autocomplete')._renderItem = (ul, item) => {
        return $('<li>').append(`<span class="description">${item.label}</span>`).appendTo(ul);
    };
}
